import React from "react";
import { Header } from "../Header/Header";
import { SubHeader } from "./SubHeader/SubHeader";
import { SearchSection } from "./SearchSection/SearchSection";
import { FeaturedProperties } from "./FeaturedProperties/FeaturedProperties";
import { ServicesOferred } from "./ServicesOferred/ServicesOferred";
import { Footer } from "./Footer/Footer";
import { ContactUs } from "./ContactUs/ContactUs";
import styles from "./Overview.module.scss";
import { useNavigate } from "react-router-dom";

export const Overview = () => {
  const navigate = useNavigate();

  const searchFn = (
    propertyType: string,
    location: string,
    businessType: string
  ) => {
    const params = new URLSearchParams({
      propertyType,
      location,
      businessType,
    }).toString();

    navigate(`/listings?${params}`);
  };
  return (
    <div className={styles.overviewBackgroundImage}>
      <div className={styles.container}>
        <Header overviewStyle={true} />
        <SubHeader overviewStyle={true} />
        <SearchSection searchFn={searchFn} />
        <FeaturedProperties />
        <ServicesOferred />
        <ContactUs />
        <Footer />
        {/* <TwoWayDividedSection title={buyersFocusedTitle} keyPoints={buyersFocusedKeyPoints} img={soldImg} />
      <TwoWayDividedSection title={sellersFocusedTitle} keyPoints={sellersFocusedKeyPoints} img={focusedOnSellersImg} isReversedMode={false} /> */}
      </div>
    </div>
  );
};